export default {
      id: "huge-x-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#huge-x",
      toString: function () {
        return this.url;
      }
    }